module.exports = __webpack_public_path__ + "img/header-pan.47efdcf1.svg";